import { render, staticRenderFns } from "./ReportingName.vue?vue&type=template&id=30b49f9a&"
import script from "./ReportingName.vue?vue&type=script&lang=js&"
export * from "./ReportingName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports